import { createFileRoute } from '@tanstack/react-router';
import { validateProposalDetailSearch } from '@/lib/proposals/proposal-detail-model';

// The open section (Summary, Proposal PDF, Signing) lives in the URL, so a deep link and the back
// button reopen it. It is not personal data.
export const Route = createFileRoute('/crm/proposals/$proposalId')({
  validateSearch: validateProposalDetailSearch,
});
